// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1rgkd","canvas":"styles-module--canvas--1BPwE"};